import { matchPath } from "react-router-dom";
import * as RouteConstants from "../constants/RouteConstants";

const STORAGE_KEY = "edexlms.pendingPath";

// Download pages that emailed links open.
const DOWNLOAD_ROUTES = [
  RouteConstants.APP_ROUTE_REPORT_DOWNLOAD,
  RouteConstants.APP_ROUTE_CERTIFICATE_BATCH_DOWNLOAD,
];

// A report or certificate download link opened while signed out is kept for
// the session and opened once the user has signed in (sign-in otherwise lands
// on the dashboard).
export const rememberDownloadPath = (pathname) => {
  if (!DOWNLOAD_ROUTES.some((route) => matchPath(route, pathname))) {
    return;
  }
  try {
    window.sessionStorage.setItem(STORAGE_KEY, pathname);
  } catch (error) {
    // Storage can be unavailable (private mode); the link then needs a second click.
  }
};

// Where a company sign-in asked to go (a path inside the app, checked with
// SsoHelper.safeTarget), opened once the user has signed in.
export const rememberSignInTarget = (pathname) => {
  if (!pathname) {
    return;
  }
  try {
    window.sessionStorage.setItem(STORAGE_KEY, pathname);
  } catch (error) {
    // Storage can be unavailable (private mode); the app then opens the home page.
  }
};

export const takePendingPath = () => {
  try {
    const pathname = window.sessionStorage.getItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY);
    return pathname;
  } catch (error) {
    return null;
  }
};
